import { Button, ButtonGroup, debounce, InputAdornment, TextField, Toolbar } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import {
  FilterAltOutlined as FilterAltOutlinedIcon,
  FilterAltOffOutlined as FilterAltOffOutlinedIcon,
} from '@mui/icons-material'
import { useExportDuplicateExceptions } from '@src/tools/error-tracker/api/exceptions-api'

interface props {
  handleSearch: (value: string) => void
  onOpenFilterClicked: () => void
  hasFilter: boolean
  handleClearFilter: () => void
  children?: React.ReactNode
}

const Header = ({ handleSearch, onOpenFilterClicked, hasFilter, handleClearFilter, children }: props) => {
  const debounceOnChange = debounce(handleSearch, 1000)
  const [handleExport, isExporting] = useExportDuplicateExceptions()

  return (
    <Toolbar disableGutters sx={{ width: '100%', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          sx={{ minWidth: '20%' }}
          onChange={(e) => debounceOnChange(e.target.value)}
          size="small"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            },
          }}
        />
        <ButtonGroup variant="text" disableElevation>
          <Button size="large" onClick={onOpenFilterClicked}>
            <FilterAltOutlinedIcon fontSize="large" color={!hasFilter ? 'inherit' : 'warning'} />
          </Button>
          <Button size="large" onClick={handleClearFilter} disabled={!hasFilter}>
            <FilterAltOffOutlinedIcon fontSize="medium" />
          </Button>
        </ButtonGroup>
      </div>
      {children}
      <Button
        variant="outlined"
        size="small"
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={() => handleExport()}
        disabled={isExporting}
      >
        {isExporting ? 'Exporting...' : 'Export Duplicates'}
      </Button>
    </Toolbar>
  )
}
export default Header
